module.exports = __webpack_public_path__ + "static/5-74189a59c088ebeaaba4c79c43e8de11.jpeg";